import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  // notifications
  {
    path: '/notifications',
    name: 'NotificationsIndexPage',
    component: () => import('@/views/notifications/Index'),
    beforeEnter: requireAuth,
  }
];

const AdminRoutes = [
  
];
export default FeRoutes;
// export default [...FeRoutes,...AdminRoutes];
